import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = (supabaseUrl && supabaseKey)
  ? createClient(supabaseUrl, supabaseKey)
  : null;

// Fallback to localStorage
const lGet = (k) => { try { return JSON.parse(localStorage.getItem(k)); } catch { return null; } };
const lSet = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} };

export async function loadData(key) {
  if (!supabase) return lGet(key);
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return lGet(key);
    const { data, error } = await supabase
      .from('crm_data')
      .select('value')
      .eq('key', key)
      .eq('user_id', user.id)
      .single();
    if (error || !data) return lGet(key);
    return JSON.parse(data.value);
  } catch { return lGet(key); }
}

export async function saveData(key, value) {
  const json = JSON.stringify(value);
  lSet(key, value);
  if (!supabase) return;
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    await supabase
      .from('crm_data')
      .upsert({
        key,
        user_id: user.id,
        value: json,
        updated_at: new Date().toISOString()
      }, { onConflict: 'key,user_id' });
  } catch (e) { console.error('Save error:', e); }
}
